import { Component, inject, OnInit, Signal } from '@angular/core';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {
  ShipmentAppEntityShipmentItemRead,
  ShipmentAttachmentAppEntityShipmentItemRead,
  ShipmentService
} from '../../../openapi';
import { Store } from '@ngrx/store';
import { loadShipmentItem } from '../../../store/actions/my-cases.actions';
import { selectLoading, selectShipment } from '../../../store/selectors/my-cases.selectors';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { LabelComponent } from '../../../common/label/label.component';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import { AlertComponent } from '../../../common/alert/alert.component';
import { SessionService } from '../../../services/ssession.service';
import { AlertContainerComponent, AlertService } from '../../../common/alert-container/alert-container.component';
import { PaymentCommonService } from '../../../services/payment.common.service';
import { environment } from '../../../../environments/environment';
import { PdfGeneratorService } from '../../../services/pdf.generator.service';

@Component({
  selector: 'app-my-case-shipment-details-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    SpinnerComponent,
    DatePipe,
    LabelComponent,
    AlertComponent,
    AlertContainerComponent,
    CurrencyPipe
  ],
  providers: [UploaderAttachmentsService, PdfGeneratorService],
  templateUrl: './my-case-shipment-details-page.component.html'
})
export class MyCaseShipmentDetailsPageComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private shipmentId: string = this.route.snapshot.params['shipmentId'];

  private caseId: string = this.route.snapshot.params['caseId'];

  private store$: Store = inject(Store);

  private paymentService: PaymentCommonService = inject(PaymentCommonService);

  private pdfGeneratorService: PdfGeneratorService = inject(PdfGeneratorService);

  public shipment: Signal<ShipmentAppEntityShipmentItemRead | null> = this.store$.selectSignal(selectShipment);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private uploaderService: UploaderAttachmentsService = inject(UploaderAttachmentsService);

  private shipmentService: ShipmentService = inject(ShipmentService);

  private alertService: AlertService = inject(AlertService);

  public token: string | null = SessionService.GetAccessToken();

  public onDownloadUPP(event: Event): void {
    const id = this.shipment()?.sourceApplication?.uuid;
    event.preventDefault();
    event.stopPropagation();
    if (id) {
      this.pdfGeneratorService.generateUPPPdf(id).toPromise().then();
    }
  }

  public goToPayment(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.paymentService.goToPay({
      clientEmail: SessionService.GetTokenData()?.email || '',
      clientFirstName: SessionService?.GetTokenData()?.firstName || '',
      clientLastName: SessionService?.GetTokenData()?.lastName || '',
      totalAmount: this.shipment()?.amount,
      descriptionOverride: `Decyzja dotycząca sprawy nr: ${this.shipment()?.caseEntity?.caseNumber || 'Test'}`,
      returnUrl: `${environment.ssl ? 'https' : 'http'}://${window.location.host}/moje-sprawy/${this.caseId}/pismo/${this.shipmentId}/status-platnosci`
    }).toPromise().then();
  }

  public onDownloadAttachment(event: Event, v: ShipmentAttachmentAppEntityShipmentItemRead): void {
    event.preventDefault();
    event.preventDefault();
    this.uploaderService.downloadAttachment(v.attachment?.id || '', v.attachment?.customName || v?.attachment?.originalName || '')
      .subscribe();
  }

  public get canConfirm(): boolean {
    return !this.shipment()?.confirmations?.length;
  }

  public get confirmationDate(): Date | null {
    return this.shipment()?.confirmations?.at(0)?.createdAt || null;
  }

  public onConfirmReceive(): void {
    this.shipmentService.confirmShipmentShipmentItem({
      id: this.route.snapshot.params['shipmentId'],
      shipment: {}
    }).subscribe(() => {
      this.store$.dispatch(loadShipmentItem({ id: this.route.snapshot.params['shipmentId'] }));
      this.alertService.show({
        title: 'Sukces!',
        content: 'Odbiór został potwierdzony',
        type: 'success'
      });
    });
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadShipmentItem({ id: this.shipmentId }));
  }
}
